<script lang="ts">
    import Vue from "vue";

    export default Vue.component("UsersTable", {
        props: {
            users: Array,
            showActive: {
                type: Boolean,
                default: true
            }
        }
    });
</script>

<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th v-if="showActive" scope="col">Active</th>
                <th scope="col">Email</th>
                <th scope="col">Display name</th>
                <th scope="col">First</th>
                <th scope="col">Last</th>
                <th scope="col">User type</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(u, i) in users" :key="u.UserId">
                <th scope="row">{{i+1}}</th>
                <td v-if="showActive">{{(!u.IsLocked && !u.Deleted) ? 'Yes' : 'No'}}</td>
                <td>
                    <a v-if="u.OrganizationUnitId" :href="`/#/admin/organizations/users/manage/${u.OrganizationUnitId}/${u.UserId}`">{{u.Email}}</a>
                    <a v-else :href="`/#/admin/organizations/users/manage/${u.UserId}`">{{u.Email}}</a>
                </td>
                <td>{{u.DisplayName}}</td>
                <td>{{u.FirstName}}</td>
                <td>{{u.LastName}}</td>
                <td>
                    <span v-if="u.IsGlobalAdmin" class="badge badge-secondary" title="Global Admin">GA</span>
                    <span v-if="u.IsOrganizationAdmin" class="badge badge-secondary" title="Organization Admin">OA</span>
                    <span v-if="u.IsWorkspaceUser" class="badge badge-secondary" title="Workspace User">WU</span>
                    <span v-if="u.IsBusinessUser" class="badge badge-secondary" title="Business User">BU</span>
                    <span v-if="u.IsServiceUser" class="badge badge-info" title="Service User">SU</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
